module.exports = __webpack_public_path__ + "static/media/ceilings_gwp_60y_n.c5f97ae3.csv";